var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpanish(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.37258 24 -2.89694e-07 18.6274 0 12C2.89694e-07 5.37258 5.37258 -2.89694e-07 12 0C18.6274 2.89694e-07 24 5.37258 24 12C24 18.6274 18.6274 24 12 24Z",
    fill: "#FFDB44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2445 7.8C21.542 3.244 17.1498 2.25106e-07 12 0C6.85017 -2.25106e-07 2.45801 3.244 0.755531 7.8L23.2445 7.8Z",
    fill: "#D90026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75553 16.2C2.45801 20.756 6.85017 24 12 24C17.1498 24 21.542 20.756 23.2445 16.2L0.75553 16.2Z",
    fill: "#D90026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpanish);
export default __webpack_public_path__ + "static/media/spanish.9d7c678be162fbcf1d6ae6adb26f4e90.svg";
export { ForwardRef as ReactComponent };